import {AsyncResult, Loaded} from 'Core/models/Async';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {SsoResponseDto} from 'Users/api';
import ssoApi from 'Users/api/ssoApi';
import {changeLegacyForms, getLegacyForms, LegacyFormActionType} from 'Users/ducks/SSO/legacyForm';

export function* getLegacyFormsFromApi(action: ReturnType<typeof getLegacyForms>) {
  const {userId, encryptedIdentifier, isNewYork} = action.payload;
  const legacyBulletin: AsyncResult<SsoResponseDto> = yield call(
    ssoApi.getLegacyBulletin,
    userId,
    isNewYork,
    encryptedIdentifier
  );

  const interactiveForm: AsyncResult<SsoResponseDto> = yield call(
    ssoApi.getLegacyForm,
    userId,
    isNewYork,
    true,
    encryptedIdentifier
  );

  const legacyForm: AsyncResult<SsoResponseDto> = yield call(
    ssoApi.getLegacyForm,
    userId,
    isNewYork,
    false,
    encryptedIdentifier
  );

  yield put(changeLegacyForms(new Loaded(legacyForm), new Loaded(interactiveForm), new Loaded(legacyBulletin)));
}

export function* getLegacyFormsSaga() {
  yield takeLatest(LegacyFormActionType.LOAD_LEGACY_FORMS, getLegacyFormsFromApi);
}

export default function*() {
  yield all([getLegacyFormsSaga()]);
}
